import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { DownloadUsers } from '../../../../services/api/user-api';
import { DownloadRoles } from '../../../../services/api/role-api';
import { DownloadDepartmentAPI, DownloadDepartments } from '../../../../services/api/department-api';
import { DownloadLogActivity } from '../../../../services/api/log-activity-api';
import { LoginContext } from '../../../../services/api/authentication-api';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectUser } from '../../../../redux/user/user-selector'

import { PulseLoader } from 'react-spinners';
import '../../../tasks/scenes/tasks-comments/shared-modal-header.scss';

import './adminDownload.scss';

class AdminDownloadConfirmPopup extends React.Component {
    constructor(Props) {
        super(Props);

        this.state = {
            type: this.props.type === 'department' ? 'departments' : this.props.type === 'log-activity' ? 'Log Activity' : this.props.type,
            loading: false
        }
    }

    submitAction = async () => {

        const { token } = this.props.currentUser

        let downloadFunc = DownloadUsers;

        switch (this.props.type) {
            case 'users':
                downloadFunc = DownloadUsers
                break;
            case 'roles':
                downloadFunc = DownloadRoles
                break;
            case 'department':
                downloadFunc = DownloadDepartments //deprecate department
                break;
            case 'log-activity':
                downloadFunc = DownloadLogActivity
                break;
            default:
                break;
        }

        if (this.props.type === 'users' || this.props.type === 'log-activity') {
            this.setState({
                loading: true
            })
            await downloadFunc(token).then(
                (result) => {
                    var file = window.URL.createObjectURL(result);
                    window.location.assign(file);
                    this.props.onHide();
                    this.setState({
                        loading: false
                    })
                },
                (error) => {
                    console.log(error)
                }
            );
        }
        else {
            downloadFunc().then(
                (result) => {
                    let file = window.URL.createObjectURL(result);
                    window.location.assign(file);
                    this.props.onHide();
                },
                (error) => {
                    console.log(error)
                }
            );
            this.props.onHide();
        }


    }

    render = () => {
        return (
            <LoginContext.Consumer>
                {
                    (state) => (
                        <div onClick={(e) => e.stopPropagation()}>
                            <Modal show={this.props.show} onHide={this.props.onHide} className="tasks-actions-popup">
                                <div className="admin-actions">
                                    <Modal.Header className="header-popup" closeButton>
                                        <Modal.Title className="actions-title">Download {this.state.type}</Modal.Title>
                                    </Modal.Header>
                                    <div className="select-member-divider-line"></div>
                                    {                                                
                                    this.state.loading === true ?
                                            <div style = {{'padding' : '50px 100px', 'textAlign' : 'center'}}>
                                                <PulseLoader></PulseLoader>
                                            </div>                                
                                        :
                                    <Modal.Body className="header-body">
                                        <h3 className="actions-task-name">Download {this.state.type}?</h3>
                                        <Button className="btn-wide" onClick={this.submitAction} variant="primary">{this.props.button}</Button>

                                        {
                                            this.props.button === "Cancel" ?
                                                <Button className="btn-wide btn-outlined" onClick={this.props.onHide} variant="primary">Back</Button>
                                                :
                                                <Button className="btn-wide btn-outlined" onClick={this.props.onHide} variant="primary">Cancel</Button>
                                        }
                                    </Modal.Body>
                                    }
                                </div>
                            </Modal>
                        </div>
                    )
                }
            </LoginContext.Consumer>
        )
    }
}

const mapState = createStructuredSelector({
    currentUser: selectUser
})

AdminDownloadConfirmPopup.contextType = LoginContext;
export default connect(mapState, null)(AdminDownloadConfirmPopup);